import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class CustomRouteReuseStategy implements RouteReuseStrategy {

 /*
        Para hacer uso de esta clase se debe añadir este contenido en la ruta donde se carga el lazyload
        {
          path: 'path',
            data: {
            shouldReuse: true,
            reusePath: 'ruta completa'
          },
          loadChildren: 'lazyload'
        }


        en el app.module:

        import { CustomRouteReuseStategy } from './custom-route-reuse';

        providers: [
            { provide: RouteReuseStrategy, useClass: CustomRouteReuseStategy }
        ]

  */

  public static handlers: { [key: string]: DetachedRouteHandle } = {};

  public shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (!!route.data && !!route.data.shouldReuse) {
      return true;
    }
    return false;
  }

  public store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    CustomRouteReuseStategy.handlers[route.data.reusePath] = handle;
  }

  public shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (!!route.data.reusePath && !!CustomRouteReuseStategy.handlers[route.data.reusePath]) {
      return true;
    }
    return false;
  }

  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    if (!!route.data && !!route.data.reusePath) {
      return CustomRouteReuseStategy.handlers[route.data.reusePath];
    }
    return null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.data && curr.data && future.data.reusePath && curr.data.reusePath) {
      return future.data.reusePath === curr.data.reusePath;
    }
    return false;
  }
}


